import { render, staticRenderFns } from "./BlogSignUpHeader.vue?vue&type=template&id=3aace200&scoped=true"
import script from "./BlogSignUpHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogSignUpHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BlogSignUpHeader.vue?vue&type=style&index=0&id=3aace200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aace200",
  null
  
)

export default component.exports